const r = (t, o) => {
  let e = "";
  return e = t > o ? `${o}+` : `${t}`, e;
};
export {
  r as getFormattedNotificationCount
};
